import type { FurnitureCategoryItemsFilter } from "./api";

export const furnitureKeys = {
  all: ["furniture"] as const,

  lists: () => [...furnitureKeys.all, "list"] as const,
  adminList: (search: string) => [...furnitureKeys.lists(), "admin", { search }] as const,
  builderList: (categoryId: number | "", search: string) =>
    [...furnitureKeys.lists(), "builder", { categoryId, search }] as const,

  categoryRollup: (search: string | null) =>
    [...furnitureKeys.all, "categoryRollup", { search }] as const,
  categoryItems: (
    search: string | null,
    category: string | null,
    filter: FurnitureCategoryItemsFilter,
    skip: number,
    limit: number,
  ) => [...furnitureKeys.all, "categoryItems", { search, category, filter, skip, limit }] as const,

  details: () => [...furnitureKeys.all, "detail"] as const,
  detail: (id: number | null) => [...furnitureKeys.details(), id] as const,
  reservationHistory: (id: number | null) =>
    [...furnitureKeys.detail(id), "reservationHistory"] as const,
};

export const categoriesKeys = {
  all: ["categories"] as const,
};

export const storageCategoriesKeys = {
  all: ["storageCategories"] as const,
};
